"use client";

import { ContentfulLivePreview } from "@contentful/live-preview";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

export default function RecipeDescription({ recipe }: { recipe: Recipe }) {
  const updateRecipe = useContentfulLiveUpdates(recipe);
  return (
    <div
      className="mx-2 py-4 text-theme-primary-dark"
      {...ContentfulLivePreview.getProps({
        entryId: recipe?.sys.id,
        fieldId: "description",
      })}
    >
      {updateRecipe?.richDescription?.json &&
        documentToReactComponents(updateRecipe.richDescription.json as any)}
    </div>
  );
}
